import React from 'react'
import axios from '@/utils/myaxios'
import moment from 'moment'
import { Link } from 'react-router-dom'
import {
    Button,
    Table,
    Input,
    Descriptions,
    Modal,
    message,
    Select,
    Form,
    DatePicker,
    InputNumber,
    Col,
    Radio,
} from 'antd'
import { tableSummaries, isMobileDevice } from '@/utils/utils'

/**
 * 禁用之前日期
 */
const disabledDate = (current) => {
    return current < moment().startOf('day')
}

const formData = {
    // 表单数据
    name: undefined,
    ticket_value: undefined,
    tunix: undefined,
    is_clone: 0,
    mids: [],
}
export default class MttTicket extends React.Component {
    state = {
        loading: false, // 是否加载中
        show: false, // 是否显示弹窗
        type: undefined, // 操作类型
        title: undefined, // 弹窗标题
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            tid: undefined,
        },
        formData: formData, // 表单数据
        data: [], // 表格数据
        matchList: [], // 比赛列表
        dataInfo: {}, // 选择的数据
        matchType: [
            // 赛事类型
            { label: this.props.language['notSeriesMatch'], value: 0 },
            { label: this.props.language['seriesMatch'], value: 1 },
        ],
    }

    componentDidMount () {
        this.fetchData()
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios
            .get('/v1/api/mtt/ticket/conf_list', {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                if (res.code === 1) {
                    this.setState({
                        loading: false,
                        queryParams: {
                            ...this.state.queryParams,
                            total: res.count || 0,
                        },
                        data: res.data || [],
                    })
                }
            })
    }

    /**
     * 获取比赛列表
     */
    fetchMatchList = async (is_clone) => {
        axios
            .get('/v1/api/mtt/match/online_list', {
                params: {
                    is_clone,
                },
            })
            .then((res) => {
                if (res.code === 1) {
                    this.setState({
                        matchList: res.data || [],
                    })
                }
            })
    }

    /**
     * 新增，编辑
     */
    handleAddOrEdit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.type === 'add') {
                    // 新增
                    axios
                        .post('/v1/api/mtt/ticket/create_conf', {
                            name: values.name,
                            ticket_value: values.ticket_value,
                            tunix: parseInt(
                                new Date(values.tunix).getTime() / 1000
                            ),
                            is_clone: values.is_clone,
                            mids: values.mids,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language['createSuccessMessage']
                                )
                                this.fetchData()
                                this.handleClose()
                            }
                        })
                } else if (this.state.type === 'edit') {
                    // 编辑
                    axios
                        .patch('/v1/api/mtt/ticket/update_conf', {
                            tid: this.state.dataInfo.id,
                            name: values.name,
                            ticket_value: values.ticket_value,
                            tunix: parseInt(new Date(values.tunix).getTime() / 1000),
                            mids: values.mids,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language['editSuccessMessage']
                                )
                                this.fetchData()
                                this.handleClose()
                            }
                        })
                } else if (this.state.type === 'editMatch') {
                    // 编辑比赛
                    axios
                        .patch('/v1/api/mtt/ticket/update_conf', {
                            tid: this.state.dataInfo.id,
                            name: this.state.dataInfo.name,
                            ticket_value: this.state.dataInfo.ticket_value,
                            tunix: parseInt(new Date(moment(this.state.dataInfo.expired_at)).getTime() / 1000),
                            mids: values.mids,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language['editSuccessMessage']
                                )
                                this.fetchData()
                                this.handleClose()
                            }
                        })
                }
            }
        })
    }

    /**
     * 切换比赛类型
     */
    handleChangeMatchType = (value) => {
        // 清空所选支持的比赛
        this.formRef.props.form.setFieldsValue({
            mids: [],
        })
        this.setState({
            formData: {
                ...this.state.formData,
                mids: [],
            },
        })
        this.fetchMatchList(value)
    }

    /**
     * 显示弹窗
     */
    handleShow = async (type, item) => {
        if (type === 'add') {
            // 新增
            this.setState({
                type,
                show: true,
                title: this.props.language['createTickets'],
            })
            this.fetchMatchList(this.state.formData.is_clone)
        } else if (type === 'edit' || type === 'editMatch') {
            // 编辑
            item.match_list = item.match_list || []
            this.setState({
                type,
                show: true,
                title: this.props.language['editTickets'],
                formData: {
                    name: item.name,
                    ticket_value: item.ticket_value,
                    tunix: moment(item.expired_at),
                    is_clone: item.is_clone,
                    mids: (() => {
                        return item.match_list.map((item) => item.mid)
                    })(),
                },
                dataInfo: item,
                matchList: item.match_list,
            })
            this.fetchMatchList(item.is_clone)
        } else if (type === 'editMatch') {
            // 编辑比赛
            item.match_list = item.match_list || []
            this.setState({
                type,
                show: true,
                title: this.props.language['editMatch'],
                formData: {
                    mids: (() => {
                        return item.match_list.map((item) => item.mid)
                    })(),
                },
                dataInfo: item,
                matchList: item.match_list,
            })
            this.fetchMatchList(item.is_clone)
        }
    }

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false })
    }

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        )
    }

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        })
    }

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    tid: undefined,
                },
            },
            () => {
                this.fetchData()
            }
        )
    }

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    {/* <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["ticketIdPlaceholder"]}
                        value={this.state.queryParams.id}
                        onChange={(value) => this.handleSetQueryParamsData("id", value)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button> */}
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow('add')}
                    >
                        {this.props.language['createTickets']}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language['total']} ${total} ${this.props.language['item']}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ['10', '20', '30', '40'],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language['ticketId']}
                            dataIndex="id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['ticketName']}
                            dataIndex="name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['ticketValue']}
                            dataIndex="ticket_value"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['matchType']}
                            dataIndex=""
                            render={(item) =>
                                this.state.matchType.find(
                                    (item2) => item2.value === item.is_clone
                                ) ?
                                    this.state.matchType.find(
                                        (item2) => item2.value === item.is_clone
                                    ).label
                                    : ''
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['supportMatch']}
                            dataIndex=""
                            render={(item) => {
                                return (
                                    <Button
                                        type="link"
                                        onClick={() =>
                                            this.handleShow('editMatch', item)
                                        }
                                    >
                                        {item.match_count}
                                    </Button>
                                )
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['expirationTime']}
                            dataIndex="expired_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['operation']}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={120}
                            render={(item) => (
                                <Button
                                    type="primary"
                                    ghost
                                    onClick={() =>
                                        this.handleShow('edit', item)
                                    }
                                >
                                    {this.props.language['edit']}
                                </Button>
                            )}
                        />
                    </Table>
                </div>

                {/* 创建，编辑弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    type={this.state.type}
                    dataInfo={this.state.dataInfo}
                    formData={this.state.formData}
                    matchType={this.state.matchType}
                    matchList={this.state.matchList}
                    handleChangeMatchType={this.handleChangeMatchType}
                    onOk={this.handleAddOrEdit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        )
    }
}

/**
 * 弹窗内容
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto',
                    }}
                >
                    <div className="container-content">
                        {/* 新增，编辑 */}
                        {(this.props.type === 'add' || this.props.type === 'edit') && (
                            <Form>
                                <Form.Item
                                    label={this.props.language['ticketName']}
                                >
                                    {getFieldDecorator('name', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    this.props.language[
                                                    'ticketNameVerify'
                                                    ],
                                            },
                                        ],
                                        initialValue: this.props.formData.name,
                                    })(
                                        <Input
                                            maxLength={16}
                                            allowClear
                                            placeholder={
                                                this.props.language[
                                                'ticketNamePlaceholder'
                                                ]
                                            }
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={this.props.language['ticketValue']}
                                >
                                    {getFieldDecorator('ticket_value', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    this.props.language[
                                                    'ticketValueVerify'
                                                    ],
                                            },
                                        ],
                                        initialValue: this.props.formData.ticket_value,
                                    })(
                                        <InputNumber
                                            min={0}
                                            max={100000000}
                                            precision={0}
                                            placeholder={
                                                this.props.language[
                                                'ticketValuePlaceholder'
                                                ]
                                            }
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        this.props.language['expirationTime']
                                    }
                                >
                                    {getFieldDecorator('tunix', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    this.props.language[
                                                    'expirationTimeVerify'
                                                    ],
                                            },
                                        ],
                                        initialValue: this.props.formData.tunix,
                                    })(
                                        <DatePicker
                                            showTime={{ format: 'HH:mm' }}
                                            format="YYYY-MM-DD HH:mm"
                                            placeholder={
                                                this.props.language[
                                                'expirationTimePlaceholder'
                                                ]
                                            }
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={this.props.language['matchType']}
                                >
                                    {getFieldDecorator('is_clone', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    this.props.language[
                                                    'matchTypeVerify'
                                                    ],
                                            },
                                        ],
                                        initialValue:
                                            this.props.formData.is_clone,
                                    })(
                                        <Radio.Group
                                            disabled={
                                                this.props.type === 'edit'
                                            }
                                            onChange={(e) =>
                                                this.props.handleChangeMatchType(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            {this.props.matchType.map(
                                                (item, index) => (
                                                    <Radio
                                                        key={index}
                                                        value={item.value}
                                                    >
                                                        {item.label}
                                                    </Radio>
                                                )
                                            )}
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={this.props.language['supportMatch']}
                                >
                                    {getFieldDecorator('mids', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    this.props.language[
                                                    'supportMatchVerify'
                                                    ],
                                            },
                                        ],
                                        initialValue: this.props.formData.mids,
                                    })(
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            showSearch
                                            optionFilterProp="children"
                                            placeholder={
                                                this.props.language[
                                                'supportMatchPlaceholder'
                                                ]
                                            }
                                        >
                                            {this.props.matchList.map(
                                                (item, index) => (
                                                    <Select.Option
                                                        key={index}
                                                        value={item.mid}
                                                    >
                                                        {item.name}（
                                                        {item.begin_time}）
                                                    </Select.Option>
                                                )
                                            )}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Form>
                        )}

                        {/* 编辑比赛 */}
                        {this.props.type === 'editMatch' && (
                            <Form>
                                <Form.Item
                                    label={this.props.language['supportMatch']}
                                >
                                    {getFieldDecorator('mids', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    this.props.language[
                                                    'supportMatchVerify'
                                                    ],
                                            },
                                        ],
                                        initialValue: this.props.formData.mids,
                                    })(
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            showSearch
                                            optionFilterProp="children"
                                            placeholder={
                                                this.props.language[
                                                'supportMatchPlaceholder'
                                                ]
                                            }
                                        >
                                            {this.props.matchList.map(
                                                (item, index) => (
                                                    <Select.Option
                                                        key={index}
                                                        value={item.mid}
                                                    >
                                                        {item.name}（
                                                        {item.begin_time}）
                                                    </Select.Option>
                                                )
                                            )}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Form>
                        )}
                    </div>
                </Modal>
            )
        }
    }
)
